<div class="notice-region" role="status" aria-live="polite">
  @for (notice of shown(); track notice.id) {
    <div #bar class="notice" [class.notice-error]="notice.kind === 'error'" [class.notice-warning]="notice.kind === 'warning'" data-cy="notice"
         [attr.data-kind]="notice.kind" appSwipe (swipedLeft)="notices.dismiss()" (swipedRight)="notices.dismiss()"
         (mouseenter)="notices.hold()" (mouseleave)="notices.release()"
         (focusin)="notices.hold()" (focusout)="notices.release()">
      <div class="notice-body" [appSheetDrag]="bar" (dismissed)="notices.dismiss()" data-cy="notice-body">
        <app-icon [name]="notice.kind === 'error' ? 'error' : notice.kind === 'warning' ? 'info' : 'check-circle'" />
        <span class="notice-text">{{ notice.text }}</span>
      </div>
      <button class="icon-btn notice-close" type="button" [attr.aria-label]="texts.close"
              (click)="notices.dismiss()" data-cy="notice-close">
        <app-icon name="close" />
      </button>
    </div>
  }
</div>
